import { render, staticRenderFns } from "./SetGameSettings.vue?vue&type=template&id=577706e2&scoped=true&lang=pug&"
import script from "./SetGameSettings.vue?vue&type=script&lang=js&"
export * from "./SetGameSettings.vue?vue&type=script&lang=js&"
import style0 from "./SetGameSettings.vue?vue&type=style&index=0&id=577706e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577706e2",
  null
  
)

export default component.exports